<template>
  <div class="content-signature">
    <label class="input-title">{{ getTitle(component.name) }}</label>
  </div>
</template>
<script>
export default {
  name: 'Signature',

  props: {
    component: {
      type: Object,
      required: true,
    },
  },

  methods: {
    getTitle(name) {
      switch (name) {
        case 'assinaturaConsultor':
          return 'INSERIR ASSINATURA DO CONSULTOR'
        case 'assinaturaProdutor':
          return 'INSERIR ASSINATURA DO PRODUTOR'
        case 'assinaturaResponsavel':
          return 'INSERIR ASSINATURA DO RESPONSÁVEL'
        default:
          return ''
      }
    },
  },
}
</script>
<style scoped>
.content-group .content-signature {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 15px;
  margin: 0;
  border-radius: 8px;
  background-color: #4255ac;
  cursor: pointer;
}

.content-signature {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 15px;
  margin: 10px;
  border-radius: 8px;
  background-color: #4255ac;
  cursor: pointer;
}

.input-title {
  font-weight: bold;
  font-size: 14;
  font-family: 'Rajdhani', sans-serif;
  color: #10dd2c;
  padding-left: 5px;
  cursor: pointer;
}
</style>
